import { Button, FormControl, FormControlLabel, FormGroup, InputLabel, MenuItem, Paper, Select, Stack, Switch, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import Loading from './Loading';
import { useCreateMetadataMutation, useDeleteMetadataMutation, useGetSKUMetadataQuery, useUpdateMetadataMutation } from '../features/products/metadataSlice';
import { MetadataSelector } from './MetadataSelector';
import { metadataOption } from '../helpers/metadata';

const MetadataEditor = ({metadata, onDelete = null, variant="default", width=300, nolabel=false, customSources={}}) => {
    let [state, setState] = useState({quantity: 0});
    const [updateMetadata] = useUpdateMetadataMutation();
    let fields = []
    let metaDef = metadataOption(metadata.key);
    console.log(metadata.key, metaDef)

    function changeValue(svalue = null, ivalue = null, fvalue = null) {
        if(svalue) {
            let updatedSku = {...metadata, svalue: svalue}
            updateMetadata({skumetadata_id: metadata.id, data: updatedSku})
            setState({...state, svalue: svalue});
        } else if (ivalue) {
            let updatedSku = {...metadata, ivalue: ivalue}
            updateMetadata({skumetadata_id: metadata.id, data: updatedSku})
            setState({...state, ivalue: ivalue});
        } else if (fvalue) {
            let updatedSku = {...metadata, fvalue: fvalue}
            updateMetadata({skumetadata_id: metadata.id, data: updatedSku})
            setState({...state, fvalue: fvalue});
        }
    }

    let gap = 5;
    let w2 = (width - gap) / 2.0;
    if(variant === "small3") width = (width - gap * 2) / 3.0;
    if(variant === "small2") width = w2;
    let wgap = width - gap;

    if(metaDef.control === "switch") {
        if(metaDef.type === "int"){
            fields.push(
                <FormControlLabel sx={{width: wgap}} key={metadata.key} control={<Switch defaultChecked={metadata.ivalue === 1} onChange={(event) => {
                    changeValue(null, event.target.checked ? 1 : 0);
                }} />} label={metaDef.label} />
            )
        } else if(metaDef.type === "string"){
            fields.push(
                <FormControlLabel sx={{width: wgap}} key={metadata.key}  control={<Switch defaultChecked={metadata.svalue === "true"} onChange={(event) => {
                    changeValue(event.target.checked ? "true" : "false");
                }} />} label={metaDef.label} />
            )
        } else {
            <div>Unknown switch type: `${metaDef.type}`</div>
        }
    } else if (metaDef.control === "select") {
        // string only
        fields.push(
            <FormControl key={metadata.key + "_ctrl"}>
                <InputLabel id={metadata.key + "_id"}>{metaDef.label}</InputLabel>
                <Select
                id={metadata.key + "_select"}
                label={metaDef.label}
                labelId={metadata.key + "_id"}
                sx={{ width: width }}
                defaultValue={metadata.svalue}
                onChange={(event) => {
                    changeValue(event.target.value);
                }}
                >
                {metaDef.source ? 
                    customSources[metaDef.source] && customSources[metaDef.source].map((option) => {
                        return <MenuItem key={option} value={option}>{option}</MenuItem>    
                    })
                :
                metaDef.options.map((option) => {
                    return <MenuItem key={option} value={option}>{option}</MenuItem>
                })}
                </Select>
            </FormControl>
            )
    } else if(metaDef.type === "string") {
        if(metaDef.size === "large") {
            fields.push(
                <TextField multiline minRows={4} maxRows={10} key={metadata.key} sx={{width: 500}} label={metaDef.label} defaultValue={metadata.svalue} onChange={(event) => {
                    changeValue(event.target.value);
                }} />
                )
            } else {
            fields.push(
            <TextField key={metadata.key} sx={{width: width}} label={metaDef.label} defaultValue={metadata.svalue} onChange={(event) => {
                changeValue(event.target.value);
            }} />
            )
        }
    } else if(metaDef.type === "int"){
        fields.push(
            <TextField key={metadata.key} sx={{width: width}} type="number" label={nolabel ? "" : metaDef.label} defaultValue={metadata.ivalue} onChange={(event) => {
                changeValue(null, event.target.value);
            }} />
        )
    } else if(metaDef.type === "float"){
        fields.push(
            <TextField key={metadata.key} sx={{width: width}} type="number" label={nolabel ? "" : metaDef.label} defaultValue={metadata.fvalue} onChange={(event) => {
                changeValue(null, null, event.target.value);
            }} />
        )
    } else if(metaDef.type === "int,float"){
        fields.push(
            <TextField key={metadata.key + "_int"} sx={{width: w2}} type="number" label={"(int) " + metaDef.label} defaultValue={metadata.ivalue} onChange={(event) => {
                changeValue(null, event.target.value);
            }} />
        )
        fields.push(
            <TextField key={metadata.key} sx={{width: w2}} type="number" label={"(float) " + metaDef.label} defaultValue={metadata.fvalue} onChange={(event) => {
                changeValue(null, null, event.target.value);
            }} />
        )
    } else {
        fields.push(<div key={metadata.key}>Unknown definition type: {metaDef.type}</div>);
    }
    let deletebutton = [];
    if(onDelete) {
        deletebutton.push(
            <Button key={`delete_$(metadata.key)`} variant="outlined" onClick={(event) => {
                if(onDelete) {
                    onDelete(metadata)
                }
                }}><DeleteIcon /></Button>
        )
    }

    if(!onDelete) {
        return <>{fields}</>
    }

    return (
        <Stack direction="row" key={metadata.id} spacing={1} textAlign="left">
            {fields}
            {deletebutton}
        </Stack>
    );
}

const ProductMetadataEditor = ({product}) => {
    const { data: metadatas, error, isLoading} = useGetSKUMetadataQuery(product.id);
    const [deleteMeta, {isLoading: isDeleting}] = useDeleteMetadataMutation();
    const [addMeta, {isLoading: isAdding}] = useCreateMetadataMutation();

    const [addingMeta, setAddingMeta] = useState(null);
    const [showHidden, setShowHidden] = useState(false);

    if (isLoading) {
      return <Loading />;
    }
    if (error) {
      return <div>Error: {error}</div>
    }

    const handleDelete = (metadata) => {
        deleteMeta(metadata.id);
    }

    let got_keys = []
    metadatas.objects.forEach(meta => {
        got_keys.push(meta.key);
    });

    let metadata_rows = metadatas.objects.filter(
        (m) => {return !(metadataOption(m.key).group)}
        ).filter((metadata) => {
            return (showHidden || !metadataOption(metadata.key).hidden)
        }).map((metadata) => 
            <MetadataEditor key={metadata.id} metadata={metadata} onDelete={handleDelete} />
    )
    let metas_per_group = metadatas.objects.filter((m) => (metadataOption(m.key).group != null)).reduce((group, meta) => {
        let group_name = metadataOption(meta.key).group;
        group[group_name] = group[group_name] ?? [];
        group[group_name].push(meta);
        return group
    }, {});
    console.log(metas_per_group);

    Object.keys(metas_per_group).forEach(key => {
        let items = metas_per_group[key];
        let style = `small${items.length}`;
        let meta_items = items.map((metadata) =>
            <MetadataEditor key={metadata.id} metadata={metadata} variant={style} />);
        metadata_rows.push(<Stack key={`$(meta_items[0].key)_group`}>
            <Typography variant="subtitle2" sx={{marginBottom: 1}}>{key}</Typography>
            <Stack direction="row" spacing={1}>{meta_items}</Stack>
            </Stack>)
    });

    return (
      <>
      <Paper variant="outlined" sx={{padding: 1}}>
        <Stack sx={{marginRight: 1}} direction="row" spacing={4} alignItems="center" justifyContent="space-between">
            <Typography key="attributesTitle" variant="subtitle1" sx={{marginBottom: 1}}>Product attributes</Typography>
            <FormGroup key="showHiddenGroup">
            <FormControlLabel key="showHidden" control={<Switch key="showHiddenCheck" checked={showHidden} onChange={(event) => {
                setShowHidden(event.target.checked);
            }} />} label="Show hidden" />
            </FormGroup>
      </Stack>
      <Stack spacing={2}>
            {metadata_rows}
      </Stack>
      <Stack direction="row" spacing={1} sx={{marginBottom: 1, marginTop: 4}}>
        <MetadataSelector exclude={got_keys} family_id={product.product_family} onSelect={(value) => {
          setAddingMeta(value);
        }} />
        <Button variant="contained" onClick={() => {
          let newMetadata = {
            SKU: product.id,
            key: addingMeta.key,
            svalue: addingMeta.defaultString,
            ivalue: addingMeta.defaultInt,
            fvalue: addingMeta.defaultFloat
          }
          addMeta(newMetadata);
          setAddingMeta(null);
        }}>Add</Button>
      </Stack>

      </Paper>
      </>
    );
}

export default ProductMetadataEditor;

export {MetadataEditor};